import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute } from '@angular/router'; //, Params

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user'

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  title : any;
  body : any;
  currentUrl:string;
  pagetitle1:string = 'About Us';
  pagetitle2:string = 'About History';
  constructor(
    public bp:BasicProvider, 
    public up:UserProvider,
    private router:Router
  ) {
    this.getData();
  }

  ngOnInit() {
    
  }

  getData(){
    this.currentUrl = this.router.url; /// this will give you current url
    //console.log(this.currentUrl);
    let url = 'pages/static_page/about';
    if( this.currentUrl == '/terms' ){
      this.pagetitle1 = 'Terms & Conditions';
      this.pagetitle2 = 'Terms & Conditions';
      url = 'pages/static_page/terms';
    } else if( this.currentUrl == '/privacy' ){
      this.pagetitle1 = 'Privacy Policy';
      this.pagetitle2 = 'Privacy Policy';
      url = 'pages/static_page/privacy';
    }
    this.bp.hitApi(url, 'GET', {})
      .subscribe(
        success => {  
          if( success.type == true ){   
            this.title = success.data.title;
            this.body = success.data.body;
          }else{
            this.bp.showAlert(success.message, this.bp.alertTitle, () => {

            } ); 
          } 
        }, 
        error => {}
      );  
  }

}



// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.ts